
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('circle',{staticClass:"fill",attrs:{"fill":"#111","fill-rule":"nonzero","cx":"12.063","cy":"15.079","r":"3.167"}}),_c('circle',{staticClass:"fill",attrs:{"fill":"#111","fill-rule":"nonzero","cx":"25.786","cy":"15.079","r":"3.167"}}),_c('circle',{staticClass:"stroke",attrs:{"stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","cx":"19","cy":"19","r":"19"}})]),_c('path',{staticClass:"stroke",attrs:{"d":"M12 25.882c1.65.62 4.7 1 8 1s6.35-.38 8-1","stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    